import guest from "@/core/middlewares/guest";

let login = () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/Login');
let oauthCallback = () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/Oauth');
let twoFactorAuthentication = () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/TwoFactorAuthentication');
let forgotPassword = () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/forgot-password/ForgotPassword');
let resetPassword = () => import(/* webpackChunkName: "authentication" */ '@/views/authentication/forgot-password/ResetPassword');

export default [
    {
        path: "/accounts",
        redirect: "/accounts/login",
        component: () => import("@/views/authentication/Layout"),
        children: [
            {
                path: "login",
                name: "login",
                component: login,
                meta: {
                    middleware: guest,
                    title: "ورود "
                }
            },
            {
                path: "oauth/:provider/callback",
                name: "oauth.callback",
                component: oauthCallback,
                meta: {
                    middleware: guest,
                    title: "ورود "
                }
            },
            {
                path: "2fa/:token",
                name: "2fa",
                component: twoFactorAuthentication,
                meta: {
                    middleware: guest,
                    title: "ورود دو مرحله ای"
                }
            },
            {
                path: "forgot-password",
                name: "forgot-password",
                component: forgotPassword,
                meta: {
                    middleware: guest,
                    title: "فراموشی گذرواژه"
                }
            },
            {
                path: "reset-password/:token",
                name: "reset-password",
                component: resetPassword,
                meta: {
                    middleware: guest,
                    title: "بازیابی گذرواژه"
                }
            }
        ]
    }
]